var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntityButtonExcel(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 486 500",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "entityButtonExcel_svg__a",
    gradientUnits: "userSpaceOnUse",
    cx: -746.66,
    cy: 781.44,
    fx: -746.66,
    fy: 781.44,
    r: 13.89,
    gradientTransform: "matrix(-28.32595 -29.80763 -23.11916 21.97986 -2596.39 -38900.309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#379539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#297c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#15561c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "entityButtonExcel_svg__b",
    gradientUnits: "userSpaceOnUse",
    cx: -773.19,
    cy: 771.25,
    fx: -773.19,
    fy: 771.25,
    r: 13.89,
    gradientTransform: "matrix(-11.97612 -11.58137 -8.95853 9.26806 -2155.12 -15858.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#073b10",
    stopOpacity: 0.698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#084a13",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "entityButtonExcel_svg__f",
    gradientUnits: "userSpaceOnUse",
    cx: -824.11,
    cy: 810.99,
    fx: -824.11,
    fy: 810.99,
    r: 13.89,
    gradientTransform: "matrix(-9.02 0 0 19.09 -7120.4 -15378.69)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4eb43b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72cc61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "entityButtonExcel_svg__h",
    gradientUnits: "userSpaceOnUse",
    cx: -769.14,
    cy: 808.9,
    fx: -769.14,
    fy: 808.9,
    r: 13.89,
    gradientTransform: "matrix(-16.9077 -13.68182 13.64112 -16.86345 -23523.37 3309.71)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#79e96d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0eb76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "entityButtonExcel_svg__i",
    gradientUnits: "userSpaceOnUse",
    cx: -675.64,
    cy: 793.28,
    fx: -675.64,
    fy: 793.28,
    r: 13.89,
    gradientTransform: "matrix(15.99197 15.99755 45.54153 -45.54797 -25315.85 47178.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20a85e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#09442a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "entityButtonExcel_svg__j",
    gradientUnits: "userSpaceOnUse",
    cx: -657.62,
    cy: 853.99,
    fx: -657.62,
    fy: 853.99,
    r: 13.89,
    gradientTransform: "matrix(0 11.2 12.9 0 -10902.85 7734.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#33a662",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#98f0b0",
    stopOpacity: 0.302
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "entityButtonExcel_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 69.43,
    y1: 210.33,
    x2: 260.84,
    y2: 210.33,
    gradientTransform: "matrix(1 0 0 -1 0 502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52d17c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4aa647"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "entityButtonExcel_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 194.4,
    y1: 335.33,
    x2: 194.4,
    y2: 161.68,
    gradientTransform: "matrix(1 0 0 -1 0 502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29852f",
    stopOpacity: 0.302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4aa647",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "entityButtonExcel_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 80.49,
    y1: 297.22,
    x2: 311.45,
    y2: 497.54,
    gradientTransform: "matrix(1 0 0 -1 0 502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66d052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85e972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "entityButtonExcel_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 182.11,
    y1: 377,
    x2: 69.43,
    y2: 377,
    gradientTransform: "matrix(1 0 0 -1 0 502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#c0e075",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1eb95"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.43 159.719c0-34.52 27.98-62.5 62.492-62.5h354.09v361.11c0 23.01-18.653 41.671-41.66 41.671H152.738c-46.008 0-83.308-37.309-83.308-83.328zm0 0",
    fill: "url(#entityButtonExcel_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.43 159.719c0-34.52 27.98-62.5 62.492-62.5h354.09v361.11c0 23.01-18.653 41.671-41.66 41.671H152.738c-46.008 0-83.308-37.309-83.308-83.328zm0 0",
    fill: "url(#entityButtonExcel_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.43 229.172c0-34.524 27.98-62.5 62.492-62.5h187.457c-23.008 0-41.66 18.656-41.66 41.668v83.332c0 23.008-18.649 41.668-41.66 41.668H152.75c-46.012 0-83.309 37.308-83.309 83.332v-187.5zm0 0",
    fill: "url(#entityButtonExcel_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.43 229.172c0-34.524 27.98-62.5 62.492-62.5h187.457c-23.008 0-41.66 18.656-41.66 41.668v83.332c0 23.008-18.649 41.668-41.66 41.668H152.75c-46.012 0-83.309 37.308-83.309 83.332v-187.5zm0 0",
    fill: "url(#entityButtonExcel_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.43 83.328C69.43 37.308 106.73 0 152.738 0h166.633v166.672H152.738c-46.008 0-83.308 37.308-83.308 83.328zm0 0",
    fill: "url(#entityButtonExcel_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.43 83.328C69.43 37.308 106.73 0 152.738 0h166.633v166.672H152.738c-46.008 0-83.308 37.308-83.308 83.328zm0 0",
    fill: "url(#entityButtonExcel_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.43 83.328C69.43 37.308 106.73 0 152.738 0h166.633v166.672H152.738c-46.008 0-83.308 37.308-83.308 83.328zm0 0",
    fill: "url(#entityButtonExcel_svg__g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M319.371 0H444.34C467.348 0 486 18.652 486 41.66v83.352c0 23.008-18.652 41.66-41.66 41.66H319.37c-23.008 0-41.66-18.652-41.66-41.66V41.66C277.71 18.652 296.363 0 319.37 0zm0 0",
    fill: "url(#entityButtonExcel_svg__h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.129 236.11h131.91c24.926 0 45.133 20.206 45.133 45.128V413.2c0 24.926-20.207 45.13-45.133 45.13H45.13C20.207 458.328 0 438.124 0 413.198V281.24c0-24.923 20.207-45.13 45.129-45.13zm0 0",
    fill: "url(#entityButtonExcel_svg__i)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.129 236.11h131.91c24.926 0 45.133 20.206 45.133 45.128V413.2c0 24.926-20.207 45.13-45.133 45.13H45.13C20.207 458.328 0 438.124 0 413.198V281.24c0-24.923 20.207-45.13 45.129-45.13zm0 0",
    fill: "url(#entityButtonExcel_svg__j)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M169.48 410.71h-34.25l-21.5-40.472c-.77-1.418-1.359-2.539-1.77-3.367-.35-.883-.741-1.89-1.151-3.012h-.348c-.531 1.422-1.031 2.57-1.5 3.45-.473.89-1.031 1.98-1.68 3.28l-22.3 40.11H52.68l38.761-63.578L55.34 283.72h33.8l19.11 36.133c.77 1.476 1.422 2.777 1.95 3.898.59 1.059 1.179 2.328 1.769 3.809h.351c.82-1.707 1.47-3.07 1.95-4.07.53-1 1.242-2.329 2.12-3.977l19.82-35.774h32.212l-36.633 62.434 37.7 64.547zm0 0",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityButtonExcel);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/entityButtonExcel.074250dc.svg";
export { MemoForwardRef as ReactComponent };